import { createAsyncThunk } from "@reduxjs/toolkit";
// Import Axios Admin API (this is where the baseURL is and shared reuqest params are set)
import api from "../../utils/api";
import { setAlert } from "../alerts/actions";

export const list = createAsyncThunk("admins/list", async (params = { page: 0, limit: 10, orderBy: null, orderDirection: null, filter: null, search: null }) => {
    try {
        const page = params.page ? params.page : 0
        const limit = params.limit ? params.limit : 10
        const res = await api.get(`/admin/admins`, { params });
        console.log(page, limit)
        return { ...res.data, page, limit };
    } catch (error) {
        console.log(error);
    }
});
export const create = createAsyncThunk("admins/create", async ({ data, navigate }, { dispatch }) => {
    try {
        const res = await api.post('/admin/admins', data);
        dispatch(list());
        dispatch(setAlert({ message: 'Admins Added successfully', alertType: 'success' }))
        if (navigate)
            navigate(`/cms/admins`);
        return res.data;
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const get = createAsyncThunk("admins/get", async (id, { dispatch }) => {
    try {
        console.log(id);
        const res = await api.get(`/admin/admins/${id}`);
        return res.data;
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const edit = createAsyncThunk("admins/edit", async ({ id, data, navigate }, { dispatch }) => {
    try {
        console.log(data);
        await api.put(`/admin/admins/${id}`, data);
        dispatch(setAlert({ message: 'Admin updated successfully', alertType: 'success' }))
        dispatch(list());
        if (navigate)
            navigate(`/cms/admins`);
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});


export const remove = createAsyncThunk("admins/remove", async (id, { dispatch }) => {
    try {
        await api.delete(`/admin/admins/${id}`);
        dispatch(setAlert({ message: 'Admin removed successfully', alertType: 'error' }))
        dispatch(list());
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});

export const bulk_remove = createAsyncThunk("admins/bulk-remove", async ({ data }, { dispatch }) => {
    try {
        await api.post(`/admin/admins/delete`, data);
        dispatch(setAlert({ message: 'Admins removed successfully', alertType: 'error' }))
        dispatch(list());
    } catch (err) {
        const errors = err.response.data.errors;
        if (errors) {
            errors.forEach((error) => dispatch(setAlert({ message: error.message, alertType: 'error' })));
        }
    }
});